import { get, post } from "./http";

export function statistics(data, custom) {
  return post("shopapi/index/statistics", data, custom);
}

export function rankinglist(data, custom) {
  return post("shopapi/index/rankinglist", data, custom);
}